import { createFileRoute } from '@tanstack/react-router'
import { requiredRoles } from '@/shared/utils/require-roles'
import { z } from 'zod'
import InvoiceNewPage from '@/pages/invoice/invoice-new-page'

/**
 * Invoice creation context types:
 * - 'standard': Create invoice from intervention (default), can toggle to down_payment
 * - 'credit_note': Create credit note for existing invoice
 * - 'without_reference': Create invoice without intervention reference
 * - 'from_quote': Create invoice from quote (future)
 */
const invoiceNewSearchSchema = z.object({
  context: z
    .enum(['standard', 'credit_note', 'without_reference', 'from_quote'])
    .optional()
    .default('standard'),
  interventionId: z.uuid().optional(),
  quoteId: z.uuid().optional(),
  originalInvoiceId: z.uuid().optional(), // For credit notes
  isDownPayment: z.boolean().optional(), // Toggle for down payment invoice
})

export type InvoiceNewSearch = z.infer<typeof invoiceNewSearchSchema>

export const Route = createFileRoute('/_invoice-flow/org/$orgId/invoices/new')({
  validateSearch: invoiceNewSearchSchema,
  // SUPER_ADMIN only — every action on this screen is an Invoice create/update/
  // delete, which the API grants to no other role; anyone else gets the 403
  // page, not a form whose every save fails (#2421).
  beforeLoad: () => {
    requiredRoles([])
  },
  component: InvoiceNewPage,
})
